import styled from 'styled-components';
import { Box, Flex, ClickableBox } from 'components/ui';
import { Link } from 'react-router-dom';
import { ReactComponent as BurnIcon } from 'img/burn.svg';
import { useState } from 'react';
import OpenseaName from 'components/OpenseaName';
import Tooltip from 'react-tooltip';
import { constants } from 'ethers';
import { OwnedNft } from 'utils/types';
import { verifyAddressesMatch } from 'utils/ethAddress';
import { useWallet } from 'components/WalletContext';

interface FuturaOwnershipInfoProps {
  itemId?: string;
  nft: OwnedNft;
}

const SLink = styled(Link)`
  color: white;
  text-decoration: underline;
`;

const FuturaOwnershipInfo = ({ nft }: FuturaOwnershipInfoProps) => {
  const { address } = useWallet();
  const isBurned = verifyAddressesMatch(nft.owner, constants.AddressZero);

  const [loadingBurnInfo] = useState(false);
  const [burnRemixId] = useState<number | undefined>(undefined);

  // The item history can be used to get minter and more info on the burn. However, we don't have the itemId
  // anymore since we are getting metadata from the indexer. Seems low priority to get this info back.
  // const [mintedBy, setMintedBy] = useState<string | undefined>(undefined);
  // const { data } = useQuery<any>(['ownershipInfo', itemId], () => fetchItemHistory(itemId));
  // const fetchTxInfo = useCallback(async txHash => {
  //   try {
  //     const provider = new providers.JsonRpcProvider(futuraRpcProvider);
  //     const receipt = await provider.getTransactionReceipt(txHash);
  //     let abi = [erc721TransferAbi];
  //     let iface = new utils.Interface(abi);
  //     const transferEvent = iface.parseLog(receipt.logs[4]);
  //     const tokenId = transferE vent.args.tokenId.toNumber();
  //     setBurnRemixId(tokenId);
  //   } catch (error) {
  //     console.error('Error parsing remix id', error);
  //   } finally {
  //     setLoadingBurnInfo(false);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     const minter = data.find(item => item.type === 'MINT')?.data.to_addr;
  //     setMintedBy(minter);

  //     const burnEvent = data.find(item => item.type === 'BURN');
  //     if (burnEvent !== undefined) {
  //       fetchTxInfo(burnEvent?.data?.tx_hash);
  //     }
  //   }
  // }, [data, fetchTxInfo]);

  const connectedUserIsOwner = verifyAddressesMatch(address, nft.owner);

  return (
    <>
      <Box height="14px">
        {!isBurned && (
          <Box fontSize="12px">
            Owned by:{' '}
            {connectedUserIsOwner ? (
              <Box display="inline" color="green" ml={1}>
                You
              </Box>
            ) : (
              <OpenseaName address={nft.owner} />
            )}
          </Box>
        )}
      </Box>
      {isBurned && !loadingBurnInfo && (
        <>
          <ClickableBox
            data-for="burned_tooltip"
            data-tip
            p={3}
            mt={4}
            mb={2}
            backgroundColor="#bb0606"
            borderRadius="8px"
          >
            <Flex alignCenter>
              <BurnIcon fill="white" />
              <Box ml={2}>
                <span>This NFT was burned </span>
                {burnRemixId && (
                  <span>
                    to create{' '}
                    <SLink to={`/futura/details/${burnRemixId}`}>`Remix #${burnRemixId}`</SLink>
                  </span>
                )}
              </Box>
            </Flex>
          </ClickableBox>
          <Tooltip id="burned_tooltip" place="top" effect="solid">
            <Box maxWidth="200px">
              Burned Mix NFTs are technically locked forever within the Futura contract and can
              never be made available again.
            </Box>
          </Tooltip>
        </>
      )}
    </>
  );
};

export default FuturaOwnershipInfo;
